import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowUpRight, Lock, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user) nav('/admin');
  }, [user, loading, nav]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Preencha e-mail e senha.');
      return;
    }
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success('Login efetuado com sucesso.');
      nav('/admin');
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Falha no login.';
      toast.error(detail);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0B0E] text-[#F5F1E8] flex flex-col">
      <header className="thesis-container py-8 flex items-center justify-between">
        <Link to="/" className="flex items-end gap-1 cursor-hover" translate="no" data-testid="admin-login-brand-link">
          <span className="font-display text-[24px] tracking-[-0.06em] text-[#F5F1E8]">Thesis</span>
          <span className="font-serif-italic text-[#C8FF61] text-[20px] -mb-[2px]">°</span>
        </Link>
        <Link to="/" className="line-link text-[13px] text-[#F5F1E8]/70 cursor-hover" data-testid="admin-login-back-link">← voltar ao site</Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-[460px] glass-strong rounded-[12px] p-8 md:p-10 reveal is-visible">
          <span className="font-mono-label text-[#C8FF61]">// AREA RESTRITA</span>
          <h1 className="mt-3 font-display-tight text-[40px] md:text-[52px] leading-[0.95]">
            Entrar no <span className="font-serif-italic kinetic-grad">painel</span>
          </h1>
          <p className="mt-3 text-[14px] text-[#8E8B85]">Use suas credenciais de administrador para gerenciar leads.</p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label className="font-mono-label text-[#8E8B85] flex items-center gap-2 mb-2">
                <Mail size={12} /> E-MAIL
              </label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email-input"
                placeholder="admin@thesis.studio"
                className="w-full bg-transparent border-b border-white/15 focus:border-[#C8FF61] outline-none py-3 text-[16px] placeholder:text-[#5C5A55] transition-colors"
              />
            </div>
            <div>
              <label className="font-mono-label text-[#8E8B85] flex items-center gap-2 mb-2">
                <Lock size={12} /> SENHA
              </label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password-input"
                placeholder="••••••••"
                className="w-full bg-transparent border-b border-white/15 focus:border-[#C8FF61] outline-none py-3 text-[16px] placeholder:text-[#5C5A55] transition-colors"
              />
            </div>
            <button type="submit" disabled={submitting}
              data-testid="admin-login-submit-button"
              className="btn-primary w-full justify-center cursor-hover disabled:opacity-60">
              {submitting ? 'Entrando...' : 'Entrar'}
              <ArrowUpRight size={18} />
            </button>
          </form>

          <p className="mt-7 text-[12px] font-mono-label text-[#8E8B85] leading-relaxed">
            * Esqueceu a senha? Entre em contato com o suporte técnico.
          </p>
        </div>
      </main>
    </div>
  );
}
